import { c as _c } from "react/compiler-runtime";
interface CreateWaveToggleProps {
  readonly enabled: boolean;
  readonly onChange: (enabled: boolean) => void;
  readonly label: string;
  readonly displayLabel?: boolean | undefined;
}
export default function CreateWaveToggle(t0) {
  const $ = _c(24);
  const {
    enabled,
    onChange,
    label,
    displayLabel: t1
  } = t0;
  const displayLabel = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== displayLabel || $[1] !== label) {
    t2 = displayLabel && <span className="tw-mr-2 tw-text-xs tw-font-medium tw-text-iron-500">{label}</span>;
    $[0] = displayLabel;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !displayLabel ? label : "";
  let t4;
  if ($[3] !== t3) {
    t4 = <span className="tw-sr-only">{t3}</span>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `tw-rounded-full tw-bg-gradient-to-b tw-p-[1px] ${enabled ? "tw-from-primary-300" : "tw-from-iron-600"}`;
  let t6;
  if ($[5] !== onChange) {
    t6 = e => onChange(e.target.checked);
    $[5] = onChange;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== enabled || $[8] !== t6) {
    t7 = <input type="checkbox" className="tw-sr-only" checked={enabled} onChange={t6} />;
    $[7] = enabled;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `tw-relative tw-flex tw-h-5 tw-w-9 tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-p-0 tw-transition-colors tw-duration-200 tw-ease-in-out ${enabled ? "tw-bg-primary-500 focus:tw-ring-2 focus-visible:tw-ring-primary-500 focus-visible:tw-ring-offset-2" : "tw-bg-iron-700 focus:tw-outline-none"}`;
  const t9 = enabled ? "true" : "false";
  const t10 = `tw-pointer-events-none tw-inline-block tw-size-4 tw-transform tw-rounded-full tw-bg-iron-50 tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out ${enabled ? "tw-translate-x-[18px]" : "tw-translate-x-0"}`;
  let t11;
  if ($[10] !== t10) {
    t11 = <span aria-hidden="true" className={t10} />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t8 || $[14] !== t9) {
    t12 = <span className={t8} role="switch" aria-checked={t9}>{t11}</span>;
    $[12] = t11;
    $[13] = t8;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12 || $[17] !== t5 || $[18] !== t7) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-2 sm:tw-gap-x-3"><div className={t5}>{t7}{t12}</div></div>;
    $[16] = t12;
    $[17] = t5;
    $[18] = t7;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t2 || $[22] !== t4) {
    t14 = <div className="tw-pl-4"><label className="tw-flex tw-cursor-pointer tw-items-center">{t2}{t4}{t13}</label></div>;
    $[20] = t13;
    $[21] = t2;
    $[22] = t4;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}